<hhsg-mapping #mappingComponent pageName="CostCenterMapping" entityName="Cost Center" searchByText="Name" [sortOptions]="sortOptions" 
    [mappingService]="_costCenterMappingService" [(mappingForm)]="mappingForm" [getDisplayName]="getDisplayName"
    (onSelectionEvent)="setAvailableCostCenters()" [mappingDetailTemplate]="customMappingDetailTemplate" >
    <ng-template #customMappingDetailTemplate let-mapping>
        <li class="modified">
            <span class="label">SMT Cost Center</span>
            <span class="value">{{ mapping.isMapped ? getCostCenterName(mapping.costCenterId) : "Unmapped" }}</span>
        </li>
    </ng-template>
    <div mappingFormBody class="body" *ngIf="mappingComponent.selection">
        <form #mappingForm="ngForm" (ngSubmit)="mappingComponent.onSave()">
            <div class="form-group">
                <label>Cost Center Name</label>
                <input maxlength="75" type="text" required name="costCenterName " [disabled]="true" [(ngModel)]="mappingComponent.selection.clientCostCenterName">
            </div>
            <div class="form-group">
                <label>SMT Cost Center</label>
                <select name="mappedCostCenter" *ngIf="availableCostCenters" [(ngModel)]="mappingComponent.selection.costCenterId">
                    <option value="0" disabled selected></option>
                    <option *ngFor="let costCenter of availableCostCenters" [value]="costCenter.id">{{ costCenter.name }}</option>                  
                </select>
            </div>
            <div class="form-group">
                <label>File Source</label>
                <input type="text" required name="costCenterSource" [disabled]="true" [(ngModel)]="mappingComponent.selection.source">
            </div>
         </form>
    </div>
</hhsg-mapping>